import {
    createChainableTypeChecker,
    PropTypeError,
} from "data/util/typeHelpers";

class EntityName {
    constructor(entityKey) {
        this.key = entityKey;
        this.entityKey = entityKey;
        this.parts = entityKey.split("/");
        this.implKey = this.parts[0];
        this.versionKey = this.parts[0] + "/" + this.parts[1];
        this.bareVersionKey = this.parts[1];
        this.bareEntityKey = this.parts[2];
    }

    static is(key) {
        if (typeof key !== "string") {
            throw new Error("Only strings may be EntityNames, not " + (typeof key));
        }
        // exactly three slash-delimited parts;
        let i = key.indexOf("/");
        if (i < 0) return false;
        i = key.indexOf("/", i + 1);
        if (i < 0) return false;
        i = key.indexOf("/", i + 1);
        return i < 0;
    }
}

// I can't figure out how to include this in the class definition...
EntityName.propType = createChainableTypeChecker((props, propName, componentName) => {
    if (EntityName.is(props[propName])) {
        return;
    }
    return new PropTypeError(`'${propName}' (supplied to ${componentName}) isn't a valid EntityName`);
});

export default EntityName;



// WEBPACK FOOTER //
// ./app/data/util/EntityName.js